export enum Feature {
  Campagne = "2027-1",
  WebTracking = "2041-1"
}
